import { render } from "./SVGClose.vue?vue&type=template&id=3d2d1f06&ts=true"
import script from "./SVGClose.vue?vue&type=script&lang=ts"
export * from "./SVGClose.vue?vue&type=script&lang=ts"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__